import { toast } from 'sonner';
import { useWebSocket, buildWsUrl } from './useWebSocket';

/**
 * Hook that connects to /api/ws/notifications and shows toasts for incoming notifications.
 * Auth: sends {"auth": token} as first message after WS connects.
 * Built on top of useWebSocket which handles StrictMode double-mount safely.
 *
 * @param {string|null} token - user auth token; hook is no-op when token is falsy
 */
export function useNotificationWS(token) {
  const url = token ? buildWsUrl('/api/ws/notifications') : null;

  useWebSocket(url, {
    onOpen: (ws) => {
      try { ws.send(JSON.stringify({ auth: token })); } catch { /* noop */ }
    },
    onMessage: (data, ws) => {
      if (data?.error === 'unauthorized') {
        try { ws.close(4001); } catch { /* noop */ }
        return;
      }
      if (data?.event === 'notification' && data.notification) {
        const n = data.notification;
        const opts = { description: n.message, duration: n.type === 'error' ? 6000 : 4500 };
        if (n.type === 'error') toast.error(n.title, opts);
        else if (n.type === 'warning') toast.warning(n.title, opts);
        else if (n.type === 'success') toast.success(n.title, opts);
        else toast(n.title, opts);
      }
    },
  });
}
